export default __webpack_public_path__ + "static/media/sanitizer.db6001f4.png";